<div class="d-flex gap-x-2 !w-full">
  <mat-form-field class="!w-24">
    <mat-label>{{ countryCodeLabel }}</mat-label>
    <mat-select [formControl]="countryCodeControl" panelClass="wide-select-panel white-scroll">
      <mat-option *ngFor="let code of countryCodes" [value]="code.code">
        <div class="d-flex justify-between !w-64 gap-x-4">
          <p>+{{ code.code }}</p>
          <p>{{ code.country }}</p>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ phoneNumberLabel }}</mat-label>
    <input matInput [formControl]="phoneNumberControl" />
  </mat-form-field>
</div>
